import { CreativeType, SharedData } from '../common/typings';

import { CANVAS_API_PATH } from './CanvasApiMethodExecutor';

type CanvasUrlParams = {
    from?: string;
    isAdaptive?: boolean;
    sharedData: SharedData;
};

export function getCanvasUrl(path: string, params: CanvasUrlParams): string {
    const splitter = path.indexOf('?') === -1 ? '?' : '&';
    const sharedData = { ...params.sharedData };
    const urlParams: {
        from?: string;
        isAdaptive?: number;
        shared_data: string;
        client_id: string;
    } = {
        shared_data: '',
        client_id: ''
    };

    if (params.isAdaptive !== undefined) {
        urlParams.isAdaptive = params.isAdaptive ? 1 : 0;
    }
    if (params.from !== undefined) {
        urlParams.from = params.from;
    }

    if (params.isAdaptive) {
        sharedData.creativeType = CreativeType.ADAPTIVE;
    } else if (params.sharedData.creativeType === CreativeType.ADAPTIVE) {
        sharedData.creativeType = CreativeType.COMMON;
    }

    urlParams.shared_data = encodeURIComponent(JSON.stringify(sharedData));
    urlParams.client_id = sharedData.clientId;

    return (
        path +
        splitter +
        Object.keys(urlParams)
            .map(key => `${key}=${urlParams[key]}`)
            .join('&')
    );
}

export function exportUrl(sharedData: SharedData): string {
    return getCanvasUrl(`${CANVAS_API_PATH}creatives`, {
        sharedData
    });
}
